import { render } from "./VideoPlayerStatsTable.vue?vue&type=template&id=6cc704bb&scoped=true"
import script from "./VideoPlayerStatsTable.vue?vue&type=script&lang=js"
export * from "./VideoPlayerStatsTable.vue?vue&type=script&lang=js"

import "./VideoPlayerStatsTable.vue?vue&type=style&index=0&id=6cc704bb&lang=scss&scoped=true"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc704bb"]])

export default __exports__